import {createAsyncThunk} from '@reduxjs/toolkit';
import {filtersApi} from 'api';
import {IEntityBase} from 'models';
import {toastNotificationManager} from 'toast-notifications';
import {prefix} from './config';

export const fetchKeyTermsThunk: any = createAsyncThunk<IEntityBase[]>(
  `${prefix} fetchKeyTerms`,
  async (_, {rejectWithValue, dispatch}) => {
    try {
      const {parsedBody} = await filtersApi.getKeyTerms();
      return parsedBody;
    } catch (error) {
      dispatch(
        toastNotificationManager.createErrorToastAction(
          error.parsedBody || error.statusText || 'Failed to fetch key terms. Unknown error occurred.'
        )
      );
      return rejectWithValue(error);
    }
  }
);
